module.exports = __webpack_public_path__ + "static/404_h-7ea90b5c8a295c17b2013016b2bc33a9.jpg";